import { Helmet } from "react-helmet-async";

const SITE_URL = "https://aselitegatherings.in";
const DEFAULT_IMAGE = `${SITE_URL}/logo.webp`;

export default function SEO({
  title = "AS Elite Gatherings | Luxury Event Management in Marthandam",
  description = "AS Elite Gatherings provides luxury weddings, corporate events, award nights, product launches and private celebrations in Marthandam, Tamil Nadu.",
  keywords = "event management Marthandam, wedding planners Tamil Nadu, corporate event planners Marthandam, stage decoration Kanniyakumari, event management company Marthandam",
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const url = `${SITE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      <meta name="author" content="AS Elite Gatherings" />
      {!noindex && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AS Elite Gatherings" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "EventPlanningService",
          "name": "AS Elite Gatherings",
          "image": "${DEFAULT_IMAGE}",
          "url": "${SITE_URL}/",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "2nd Floor, AS Elite, No:114G, Railway Station Road",
            "addressLocality": "Marthandam",
            "addressRegion": "Tamil Nadu",
            "postalCode": "629165",
            "addressCountry": "IN"
          },
          "telephone": "+916382282058",
          "email": "aselitegatherings@gmail.com",
          "priceRange": "$$",
          "author": {
  "@type": "Organization",
  "name": "AS Elite Gatherings",
  "url": "https://aselitegatherings.in/"
},
"publisher": {
  "@type": "Organization",
  "name": "AS Elite Gatherings",
  "url": "https://aselitegatherings.in/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://aselitegatherings.in/logo.webp"
  }
},
          "sameAs": [
            "https://www.instagram.com/aselite_gatherings/",
            "https://www.facebook.com/aselitegatherings213",
            "https://www.youtube.com/@aselitegathering"
          ]
        }
        `}
      </script>
    </Helmet>
  );
}
